const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const DOMAIN_REGEX = /\.[a-zA-Z]{2,}$/;

export function getEmailValidationError(email, { required = false } = {}) {
  if (!email) {
    return required ? 'Email address is required' : null;
  }

  if (!email.includes('@')) {
    return 'Email must contain an @ symbol';
  }
  if (!email.includes('.')) {
    return 'Email must contain a domain (e.g., .com, .org)';
  }
  if (!DOMAIN_REGEX.test(email)) {
    return 'Email must have a valid domain extension (e.g., .com, .org, .edu)';
  }
  if (!EMAIL_REGEX.test(email)) {
    return 'Please enter a valid email address';
  }

  const [local, domain] = email.split('@');
  if (!local || !domain) {
    return 'Email format is invalid';
  }

  return null;
}

export function isValidEmail(email) {
  return getEmailValidationError(email) === null;
}

export function getPhoneValidationError(phone, { required = false } = {}) {
  if (!phone) {
    return required ? 'Phone number is required' : null;
  }

  const digits = phone.replace(/\D/g, '');

  if (digits.length !== 10) {
    return 'Phone number must be exactly 10 digits';
  }

  if (/^(\d)\1{9}$/.test(digits)) {
    return 'Please enter a valid phone number';
  }

  return null;
}

export function isValidPhone(phone) {
  return getPhoneValidationError(phone) === null;
}
